import React, { useReducer, createContext } from 'react';
import type {
  ProjectsState,
  ProjectsAction,
  ProjectsContextValue,
} from '../types';

const ProjectsContext = createContext<ProjectsContextValue>(undefined as any);

const initialState: ProjectsState = {
  search: '',
  filters: {
    status: 'All',
    client: null,
    funder: null,
    projectLead: null,
    deadline: 0,
  },
};

export const ACTIONS = {
  SET_FILTERS: 'SET_FILTERS' as const,
  SET_SEARCH: 'SET_SEARCH' as const,
  CLEAR_FILTERS: 'CLEAR_FILTERS' as const,
};

const reducer = (
  state: ProjectsState = initialState,
  { type, value }: ProjectsAction,
): ProjectsState => {
  switch (type) {
    case ACTIONS.SET_FILTERS:
      return { ...state, filters: value };
    case ACTIONS.CLEAR_FILTERS:
      return { ...state, filters: initialState.filters };
    case ACTIONS.SET_SEARCH:
      return { ...state, search: value };
    default:
      return state;
  }
};

function ProjectsProvider(props: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <ProjectsContext.Provider value={value}>
      {props.children}
    </ProjectsContext.Provider>
  );
}

export { ProjectsContext, ProjectsProvider };
